import { lazy, Suspense } from "react";
import type { TemplateProps } from "./types";
import { ClassicTemplate } from "./templates/ClassicTemplate";
import { PersonaTemplate } from "./templates/PersonaTemplate";
import { CuradoriaTemplate } from "./templates/CuradoriaTemplate";
import { IndiceTemplate } from "./templates/IndiceTemplate";
import { EstudioTemplate } from "./templates/EstudioTemplate";
import { DiarioTemplate } from "./templates/DiarioTemplate";
import { RitualDiaryTemplate } from "./templates/RitualDiaryTemplate";

const Gallery3DTemplate = lazy(() =>
  import("./templates/Gallery3DTemplate").then((m) => ({ default: m.Gallery3DTemplate })),
);

const ArtGalleryTemplate = lazy(() =>
  import("./templates/ArtGalleryTemplate").then((m) => ({ default: m.ArtGalleryTemplate })),
);

export function MiniSiteRenderer(props: TemplateProps) {
  switch (props.config.template_id) {
    case "ritual-diary":
      return <RitualDiaryTemplate {...props} />;
    case "classic":
      return <ClassicTemplate {...props} />;
    case "persona":
      return <PersonaTemplate {...props} />;
    case "indice":
      return <IndiceTemplate {...props} />;
    case "estudio":
      return <EstudioTemplate {...props} />;
    case "curadoria":
      return <CuradoriaTemplate {...props} />;

    case "gallery3d":
      return (
        <Suspense fallback={<div className="min-h-screen w-full bg-black" />}>
          <Gallery3DTemplate {...props} />
        </Suspense>
      );
    case "art-gallery":
      return (
        <Suspense fallback={<div className="min-h-screen w-full bg-black" />}>
          <ArtGalleryTemplate {...props} />
        </Suspense>
      );
    case "diario":
    default:
      return <DiarioTemplate {...props} />;

  }
}
